// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"fb0f8dba","418":"1ecfde58"}[chunkId] + ".js";
};